import { useContext } from 'react'

import GuestJourneyContext from 'contexts/GuestJourneyContext'

const useGuestJourney = () => {
  const context = useContext(GuestJourneyContext)

  if (context === undefined) {
    throw new Error(
      'useGuestJourney must be used within GuestJourneyContext.Provider',
    )
  }

  return {
    accessToken: context.accessToken,
    activeStep: context.activeStep,
    companyInfo: context.companyInfo,
    disableRecaptcha: context.disableRecaptcha,
    guestModule: context.guestModule,
    handleAcceptedRecaptcha: context.handleAcceptedRecaptcha,
    handleNext: context.handleNext,
    linkInvalid: context.linkInvalid,
    portalToken: context.portalToken,
    recaptcha: context.recaptcha,
    recaptchaRef: context.recaptchaRef,
    redirectPath: context.redirectPath,
    resetRecaptcha: context.resetRecaptcha,
    setAccessToken: context.setAccessToken,
    setActiveStep: context.setActiveStep,
    setUser: context.setUser,
    user: context.user,
  }
}

export default useGuestJourney
